import React from 'react';
import { CustomColumns, CustomColumnsBaseProps } from './CustomColumns';
import { CustomColumnsDragAndDrop } from './CustomColumnsDragAndDrop';
import { setCustomColumnsState } from '../../state/initCustomColumns';

export interface CustomColumnsFullProps extends CustomColumnsBaseProps {
  /**
   * @deprecated
   * No need to pass `dragAndDrop`, enabled by default. To opt-out `dragAndDrop`, use `import { CustomColumnsLite } from '@wix/cairo';`
   */
  dragAndDrop?: typeof CustomColumnsDragAndDrop;
}

export function CustomColumnsFull(props: CustomColumnsFullProps) {
  return <CustomColumns {...props} dragAndDrop={CustomColumnsDragAndDrop} />;
}

CustomColumnsFull.setCustomColumnsState = setCustomColumnsState;
CustomColumnsFull.dragAndDrop = CustomColumnsDragAndDrop;
CustomColumnsFull.displayName = 'CustomColumns';
